var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.77778 1V4.21111C4.77778 4.74005 4.77778 5.00452 4.88072 5.20655C4.97126 5.38426 5.11574 5.52874 5.29345 5.61928C5.49548 5.72222 5.75995 5.72222 6.28889 5.72222H12.7111C13.24 5.72222 13.5045 5.72222 13.7065 5.61928C13.8843 5.52874 14.0287 5.38426 14.1193 5.20655C14.2222 5.00452 14.2222 4.74005 14.2222 4.21111V1.94444M14.2222 18V11.9556C14.2222 11.4266 14.2222 11.1621 14.1193 10.9601C14.0287 10.7824 13.8843 10.6379 13.7065 10.5474C13.5045 10.4444 13.24 10.4444 12.7111 10.4444H6.28889C5.75995 10.4444 5.49548 10.4444 5.29345 10.5474C5.11574 10.6379 4.97126 10.7824 4.88072 10.9601C4.77778 11.1621 4.77778 11.4266 4.77778 11.9556V18M18 6.97407V13.4667C18 15.0535 18 15.8469 17.6912 16.453C17.4195 16.9861 16.9861 17.4195 16.453 17.6912C15.8469 18 15.0535 18 13.4667 18H5.53333C3.94652 18 3.15311 18 2.54703 17.6912C2.0139 17.4195 1.58046 16.9861 1.30881 16.453C1 15.8469 1 15.0535 1 13.4667V5.53333C1 3.94652 1 3.15311 1.30881 2.54703C1.58046 2.0139 2.0139 1.58046 2.54703 1.30881C3.15311 1 3.94652 1 5.53333 1H12.0259C12.4879 1 12.7189 1 12.9363 1.05219C13.1291 1.09846 13.3133 1.17478 13.4823 1.27835C13.6729 1.39516 13.8363 1.5585 14.163 1.88519L17.1148 4.83703C17.4415 5.16372 17.6048 5.32706 17.7217 5.51768C17.8252 5.68669 17.9015 5.87094 17.9478 6.06367C18 6.28106 18 6.51206 18 6.97407Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinticon);
export default __webpack_public_path__ + "static/media/printicon.2bc8582b9178376a55d8a0c85b4c7246.svg";
export { ForwardRef as ReactComponent };